/* projects/speaker-platform/src/app/molecules/admin/speaker-selector/speaker-selector.component.scss */
/*# sourceMappingURL=speaker-selector.component-IB2G3MZW.css.map */
